export const proceduresStatusHash = {
  completed: "bg-green-105 bg-green-100 text-green-800",
  scheduled: "bg-yellow-50 text-yellow-600",
  planned: "bg-blue-50 text-blue-600"
}
